import React from 'react';
import mapImage from '../assets/Snímek obrazovky 2024-08-02 v 10.52.02.png';
import logo from '../assets/logo.png'; // Import loga
import smallPizzaLogo from '../assets/smallPizzaLogo.png'; // Import malého loga pizzy
import otherLogo from '../assets/otherLogo.png'; // Import jiného loga pro Staňkov
import './HomePage.css';
import { Link } from 'react-router-dom';

const HomePage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <header className="header h-[20vh] flex items-center justify-center">
        <Link to="https://www.pizzapointwest.cz">
        <img src={logo} alt="Pizzeria Logo" className="w-full h-full object-cover" /> {/* Logo vyplní celý navbar */}        </Link>
      </header>
      <div className="flex flex-grow h-[80vh] flex-wrap justify-around">
        <BranchLink 
          href="/branch1"
          name="Menu Point Chotěšov"
          offers="Polední menu"
          address="Plzeňská 211, Chotěšov"
          summerHours="Po-Pá: 10:00 - 14:00"
          winterHours="Po-Pá: 10:00 - 14:00"
          className="branch-info-light"
          logo={otherLogo} // Jiná logo pro Staňkov
        />
        <BranchLink 
          href="/branch2"
          name="Pizza Point Holýšov"
          address="Táborová 758, Holýšov"
          summerHours="Po-Čt: 11:00 - 20:30<br/>Pá: 11:00 - 21:00<br/>So: 12:00 - 21:00<br/>Ne: 12:00 - 20:30"
          winterHours="Po-Čt: 11:00 - 20:00<br/>Pá: 11:00 - 20:30<br/>So: 12:00 - 20:30<br/>Ne: 12:00 - 20:00"
          className="branch-info-medium"
          logo={smallPizzaLogo} // Logo pro Holýšov
        />
        <BranchLink 
          href="/branch3"
          name="Pizza Point Staňkov"
          address="Náměstí T.G.M 48, Staňkov"
          summerHours="Po-Čt: 11:00 - 20:30<br/>Pá: 11:00 - 21:00<br/>So: 12:00 - 21:00<br/>Ne: 12:00 - 20:30"
          winterHours="Po-Čt: 11:00 - 20:00<br/>Pá: 11:00 - 20:30<br/>So: 12:00 - 20:30<br/>Ne: 12:00 - 20:00"
          className="branch-info-dark"
          logo={smallPizzaLogo} // Logo pro Holýšov
        />
      </div>
    </div>
  );
};

const BranchLink = ({ href, name, info, offers, address, summerHours, winterHours, className, logo }) => {
  const getHours = () => {
    const today = new Date();
    const day = today.getDate();
    const month = today.getMonth() + 1; // měsíce jsou indexovány od 0
  
    // Zimní sezóna: 16. září - 14. duben
    if ((month === 9 && day >= 16) || (month === 10) || (month === 11) || 
        (month === 12) || (month === 1) || (month === 2) || (month === 3) || 
        (month === 4 && day <= 14)) {
      return winterHours;
    } 
    
    // Letní sezóna: 15. duben - 15. září
    return summerHours;
  };

  const formatHours = (hours) => {
    return (
      <div dangerouslySetInnerHTML={{ __html: hours }} />
    );
  };

  return (
    <a href={href} className={`branch-link p-4 w-full md:w-1/3 ${className}`}>
      <div className="branch-info flex flex-col justify-between relative h-full">
        <div>
          <h2 className="text-2xl font-bold">{name}</h2>
          <p>{info}</p>
          <p>{offers}</p>
          <p>{address}</p>
          <p className="opening-hours">Otvírací doba:<br />{formatHours(getHours())}</p>
        </div>
        <div className="more-info-container">
          <p className="more-info text-right underline">Naše nabídka -></p>
        </div>

      </div>
    </a>
  );
};

export default HomePage;